import classnames from 'classnames';
import React from 'react';
import { withState } from 'recompose';
import { SortableHandle } from '../../lib/react-sortable-hoc/index';
import './CollapsibleItem.scss';

const CollapsibleItemDragContainer = SortableHandle(() => (
  <div className="collapsible-item-header-drag-container" />
));

const CollapsibleItemBody = props => {
  const { children } = props;
  return <div className="collapsible-item-body">{children}</div>;
};

const CollapsibleItemHeader = props => {
  const { children, title, className } = props;

  const classNames = classnames('collapsible-item-header', className);

  return (
    <div className={classNames}>
      <CollapsibleItemDragContainer />

      <div className="collapsible-item-header__title">{title}</div>
      <div className="collapsible-item-header__right-section">{children}</div>
    </div>
  );
};

const withExpanded = withState('isExpanded', 'setIsExpanded', true);

const CollapsibleItem = withExpanded(props => (
  <div className="collapsible-item">{props.render(props)}</div>
));

export {
  CollapsibleItem,
  CollapsibleItemHeader,
  CollapsibleItemBody,
  withExpanded,
};
